import React from 'react'
import ListPage from 'components/cases/listpage/ListPage'

interface pageProps {
  pageId: number
}
export const categoryTitle = 'クラウドネイティブ'
export const baseUrl = '/cases/cloudnative/'

const Template: React.FC<pageProps> = ({ pageId }) => {
  return <ListPage categoryTitle={categoryTitle} baseUrl={baseUrl} pageId={pageId} />
}

export default Template
